import type { Task, TaskResult, TaskStatus } from "@/kernel/runner";

/** Общая разметка клетки сетки — для черновика и для серверного прогона. */
export const CELL = "grid aspect-square place-items-center rounded-[3px] border font-mono text-[10px]";

// S8: у всех клеток сплошная рамка (в S8 нет пунктирного idle).
export const CELL_LOOK: Record<TaskStatus, string> = {
  passed: "border-ok bg-oksoft text-ok",
  failed: "border-err bg-errsoft text-err",
  idle: "border-bd2 bg-transparent text-mut",
};
const word: Record<TaskStatus, string> = { passed: "прошла", failed: "упала", idle: "не запускалась" };

/** Карточка «автопроверки K / N» с сеткой задач в 7 колонок. */
export function AutocheckGrid({ tasks, results, passed }: { tasks: Task[]; results: Record<string, TaskResult>; passed: number }) {
  return (
    <section className="rounded-md border border-bd bg-card p-3">
      <div className="mb-2.5 flex items-baseline justify-between">
        <h2 className="m-0 font-mono text-[10.5px] font-normal text-mut">автопроверки</h2>
        <span className="font-mono text-[11px] text-ink2" data-testid="autocheck-value">
          {passed} / {tasks.length}
        </span>
      </div>
      <ul className="m-0 grid list-none grid-cols-7 gap-[5px] p-0" aria-label="автопроверки по задачам" data-testid="autocheck-grid">
        {tasks.map((t) => {
          const r = results[String(t.n)];
          const s: TaskStatus = r?.status ?? "idle";
          const title = `Задача ${t.n}: ${t.title}${s === "failed" && r?.error ? ` — ${r.error}` : ""}`;
          return (
            <li key={t.n} title={title} data-status={s} className={`${CELL} ${CELL_LOOK[s]}`}>
              {t.n}
              <span className="sr-only"> — {word[s]}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export const STATUS_WORD = word;
